import {ICartItemImage} from "@connox/typescript-library";
import * as React from "react";

interface IItemThumbProps {
  images: ICartItemImage[];
  link: string;
  text: string;
}

export class ItemThumb extends React.Component<IItemThumbProps> {
  public render() {
    const {link, text, images} = this.props;

    const image1x = images
      .filter((image) => image.mediaTypeId === 100016)[0]
      .sizes.filter((size) => size.name === "half-2x")[0].url;
    const image2x = images
      .filter((image) => image.mediaTypeId === 100016)[0]
      .sizes.filter((size) => size.name === "full-2x")[0].url;
    const srcSet = `${image1x} 1x, ${image2x} 2x`;

    return (
      <div className={"ItemThumb"}>
        <a href={link} title={text}>
          <img src={image1x} srcSet={srcSet} alt={text} />
        </a>
      </div>
    );
  }
}
